<script>
export default {
  name: 'DocumentButtons'
}
</script>

<template>
  <div class="document-buttons d-flex align-items-center">
    <slot></slot>
  </div>
</template>

<style scoped lang="scss">
.document-buttons {
  gap: 10px;
}
</style>
